import FilterClose from "../../../assets/icons/FilterClose";
import SidePanelBackIcon from "../../../assets/icons/SidePanelBackIcon";
import TickIcon from "../../../assets/icons/TickIcon";
import useIsMobile from "../../../app/hooks/useIsMobile";
import CloseIcon from "../../VerticalPlayer/Icons/Close";
import "./SidePanel.css";
import React from "react";

interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: any;
  selectedTool?: any;
  setSelectedFilter?: any;
}

const SidePanel: React.FC<SidePanelProps> = ({
  isOpen,
  onClose,
  title,
  children,
  className,
  selectedTool,
  setSelectedFilter,
}) => {
  const isMobile = useIsMobile();
  const handleFilterReset = () => {
    setSelectedFilter({
      filterName: "normal",
      filterValue: "none",
    });
    onClose();
    localStorage.removeItem("filterName");
  };

  return (
    <div
      className={`side-panel-overlay ${isOpen ? "open" : ""}`}
      onClick={onClose}
    >
      <div
        className={`side-panel ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="side-panel-header">
          {selectedTool === "music" && isMobile && (
            <button className="back-btn" onClick={onClose}>
              <SidePanelBackIcon />
            </button>
          )}
          <h2>{title}</h2>
          {(selectedTool !== "filter" || !isMobile) && (
            <button className="close-btn" onClick={onClose}>
              <CloseIcon width="40" height="40" />
            </button>
          )}
          {selectedTool === "filter" && isMobile && (
            <button className="close-btn left-4" onClick={handleFilterReset}>
              <FilterClose />
            </button>
          )}
          {selectedTool === "filter" && isMobile && (
            <button className="close-btn" onClick={onClose}>
              <TickIcon />
            </button>
          )}
        </div>
        <div className="side-panel-content">{children}</div>
      </div>
    </div>
  );
};

export default SidePanel;
